<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>I am Tasneem. Born and raised in the UAE, now I am a resident of this wonderful country. I am a Certified Human Resources Professional, a Motivation Counsellor, and a community worker.</p>
<p>This book will be my first write-up, and I will be writing more books in coming years, and would love to be known as a successful author.</p>
<p>In need of your love, support and prayers for me.</p>
<p>Thanks</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?660f0452